import { formatDate } from './bits.jsx';

export default function CourseView({ entity }) {
  return (
    <>
      <dl className="quiz-facts">
        <div>
          <dt>Department</dt>
          <dd>{entity?.departmentName || entity?.department?.name || '—'}</dd>
        </div>
        <div>
          <dt>Duration</dt>
          <dd>{entity?.duration ? `${entity.duration}` : '—'}</dd>
        </div>
        <div>
          <dt>Fees</dt>
          <dd>{entity?.fees ?? entity?.courseFees ?? '—'}</dd>
        </div>
        <div>
          <dt>Added</dt>
          <dd>{formatDate(entity?.createdAt)}</dd>
        </div>
      </dl>

      {entity?.description && (
        <>
          <h5 className="pgm-section-title">About</h5>
          <p className="lp-prose">{entity.description}</p>
        </>
      )}
    </>
  );
}
